import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { distinctUntilChanged, map } from 'rxjs/operators';
import { EndpointService } from '../endpoints.service';
import {
  AdminDashboardStats,
  AdminUserResponse,
  AdminCompanyResponse
} from '../models/response.module';
import { GetResponse, PaginationResponse } from '../models/global/response-wrapper.service';

export interface AdminUsersFilter {
  page?: number;
  per_page?: number;
  search?: string;
  order_by?: string;
  sort?: 'asc' | 'desc';
  compact?: boolean;
  active_only?: boolean;
  is_trainer?: boolean;
}

export interface AdminCompaniesFilter {
  page?: number;
  per_page?: number;
  search?: string;
  order_by?: string;
  sort?: 'asc' | 'desc';
  compact?: boolean;
  company_type?: string;
  category_id?: number;
  active_only?: boolean;
}

@Injectable({ providedIn: 'root' })
export class AdminService {
  private dashboardStatsSubject = new BehaviorSubject<AdminDashboardStats | null>(null);
  public dashboardStats = this.dashboardStatsSubject.asObservable().pipe(distinctUntilChanged());

  constructor(private endpointService: EndpointService) {}

  // Dashboard
  getDashboardStats(): Observable<GetResponse<AdminDashboardStats>> {
    return this.endpointService.adm_dsh_0().pipe(
      map((response) => {
        this.dashboardStatsSubject.next(response.data);
        return response;
      })
    );
  }

  // Users
  getUsers(filters: AdminUsersFilter = {}): Observable<PaginationResponse<AdminUserResponse[]>> {
    return this.endpointService.adm_usr_0(filters);
  }

  getUser(userId: string): Observable<GetResponse<AdminUserResponse>> {
    return this.endpointService.adm_usr_1(userId);
  }

  // Companies
  getCompanies(filters: AdminCompaniesFilter = {}): Observable<PaginationResponse<AdminCompanyResponse[]>> {
    return this.endpointService.adm_coy_0(filters);
  }

  getCompany(companyId: string): Observable<GetResponse<AdminCompanyResponse>> {
    return this.endpointService.adm_coy_1(companyId);
  }

  // Google Places
  searchPlaces(query: string, location?: string): Observable<GetResponse<any[]>> {
    return this.endpointService.adm_plc_0({ query, location });
  }

  addPlaceAsCompany(placeData: any): Observable<GetResponse<any>> {
    return this.endpointService.adm_plc_1(placeData);
  }
}
